import { render } from "./CrossIcon.vue?vue&type=template&id=08081cde"
const script = {}
script.render = render

export default script